import { dynamicResolveHost } from './dynamics/resolve-host'
import { isBrowser } from './env'

export function getSelfServerOrigin() {
  if (isBrowser()) {
    return window.location.origin
  }
  return `http://${process.env.IP || 'localhost'}:${process.env.PORT || 3000}`
}

export async function cacheResolveHost(host: string) {
  if (isBrowser() && window._resolvedHost) {
    return window._resolvedHost
  }

  const _resolvedHost = await dynamicResolveHost((resolveHost) => {
    return resolveHost(host)
  })
  return _resolvedHost
}
